module.exports = __webpack_public_path__ + "static/media/map.76e1d599.jpg";